import { MotionPathPlugin } from "gsap/dist/MotionPathPlugin";
import { gsap } from "gsap/dist/gsap";

export default function fadeMotionPath(
  imagesTl,
  images,
  optionsAnimImages,
  sectionName
  // svgPathOrder,
  // imageOrder
) {
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
  }

  gsap.set(`.${sectionName}-image`, { opacity: 0 });

  // fadeIn with moving on the svg path
  // multiples images
  if (optionsAnimImages.svgPathOrder) {
    images.forEach((image, i) => {
      const animations = gsap.to(image, {
        opacity: 1,
        duration: optionsAnimImages.duration,
        motionPath: {
          path: `#${sectionName}-path-${optionsAnimImages.svgPathOrder[i]}`,
          align: `#${sectionName}-path-${optionsAnimImages.svgPathOrder[i]}`,
          // alignOrigin: optionsAnimImages.alignsOrder[i],
          alignOrigin: () => {
            if (optionsAnimImages.mobileAlignsOrder) {
              return window.innerWidth >= 375
                ? optionsAnimImages.alignsOrder[i]
                : optionsAnimImages.mobileAlignsOrder[i];
            } else return optionsAnimImages.alignsOrder[i];
          },
          start: optionsAnimImages.startOrder[i],
          end: () => {
            if (optionsAnimImages.mobileEndOrder) {
              return window.innerWidth >= 375
                ? optionsAnimImages.endOrder[i]
                : optionsAnimImages.mobileEndOrder[i];
            } else return optionsAnimImages.endOrder[i];
          },
        },
      });

      imagesTl.add(animations, "same-time");
    });
    // one images images
  } else {
    imagesTl.to(`.${sectionName}-image-1`, {
      duration: optionsAnimImages.duration,
      opacity: 1,
      motionPath: {
        path: `#${sectionName}-path-${optionsAnimImages.svgPath}`,
        align: `#${sectionName}-path-${optionsAnimImages.svgPath}`,
        alignOrigin: optionsAnimImages.alignOrigin,
        start: optionsAnimImages.start,
        end: optionsAnimImages.end,
      },
    });
  }

  // if rotationIninitly is true
  // if (optionsAnimImages.isRotatingInfinitly) {
  //   // // multiple images
  //   // if (optionsAnimImages.svgPathOrder) {
  //   //   images.forEach((image, i) => {
  //   //     // go to point 0
  //   //     const part2 = gsap.to(image, {
  //   //       duration: i === 0 || i === 1 ? getRandomInt(200, 210) : getRandomInt(40, 50),
  //   //       ease: "linear",
  //   //       motionPath: {
  //   //         path: `#${sectionName}-path-${optionsAnimImages.svgPathOrder[i]}`,
  //   //         align: `#${sectionName}-path-${optionsAnimImages.svgPathOrder[i]}`,
  //   //         alignOrigin: optionsAnimImages.alignsOrder[i],
  //   //         start: optionsAnimImages.endOrder[i],
  //   //         end: () => {
  //   //           if (
  //   //             optionsAnimImages.endOrder[i] > optionsAnimImages.startOrder[i]
  //   //           ) {
  //   //             return 0.5;
  //   //           } else return 0;
  //   //         },
  //   //       },
  //   //     });

  //   //     // start infinite rotation
  //   //     const part3 = gsap.to(image, {
  //   //       duration: i === 0 || i === 1 ? getRandomInt(200, 210) : getRandomInt(40, 50),
  //   //       repeat: -1,
  //   //       ease: i % 2 == 0 ? "circ.inOut" : "power3.inOut",
  //   //       // ease: "power3.inOut",
  //   //       motionPath: {
  //   //         path: `#${sectionName}-path-${optionsAnimImages.svgPathOrder[i]}`,
  //   //         align: `#${sectionName}-path-${optionsAnimImages.svgPathOrder[i]}`,
  //   //         alignOrigin: optionsAnimImages.alignsOrder[i],
  //   //         start: () => {
  //   //           if (
  //   //             optionsAnimImages.endOrder[i] > optionsAnimImages.startOrder[i]
  //   //           ) {
  //   //             return 0;
  //   //           } else return 0.5;
  //   //         },
  //   //         end: () => {
  //   //           if (
  //   //             optionsAnimImages.endOrder[i] > optionsAnimImages.startOrder[i]
  //   //           ) {
  //   //             return 0.5;
  //   //           } else return 0;
  //   //         },
  //   //       },
  //   //     });

  //   //     imagesTl.add(part2, "start-rotation");
  //   //     imagesTl.add(part3, ">");
  //   //   });

  //     // one image
  //   } else {
  //     imagesTl
  //       .to(`.${sectionName}-image-1`, {
  //         duration: 58,
  //         ease: "linear",
  //         motionPath: {
  //           path: `#${sectionName}-path-${optionsAnimImages.svgPath}`,
  //           align: `#${sectionName}-path-${optionsAnimImages.svgPath}`,
  //           alignOrigin: optionsAnimImages.alignOrigin,
  //           start: optionsAnimImages.end,
  //           end: 0.5,
  //         },
  //       })
  //       .to(`.${sectionName}-image-1`, {
  //         duration: 60,
  //         repeat: -1,
  //         ease: "circ.inOut",
  //         motionPath: {
  //           path: `#${sectionName}-path-${optionsAnimImages.svgPath}`,
  //           align: `#${sectionName}-path-${optionsAnimImages.svgPath}`,
  //           alignOrigin: optionsAnimImages.alignOrigin,
  //           start: 0,
  //           end: 0.5,
  //         },
  //       });
  //   }
  // }
}
